/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.learning.center.user.progress.rpc.AchievementChirpService
 */
import * as References from './AchievementChirpService';
import { createRpcClientV2 } from 'rpc-client-utils';
import http from 'hub-http/clients/apiClient';
import { registerQuery, registerMutation } from 'data-fetching-client/next';
const chirpClient = createRpcClientV2({
  hubHttpClient: http
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.learning.center.user.progress.rpc.AchievementChirpService#createAchievement
 */
export const CREATE_ACHIEVEMENT_MUTATION_FIELD_NAME = 'com_hubspot_learning_center_user_progress_rpc_AchievementChirpService_createAchievement';
export const CREATE_ACHIEVEMENT_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: CREATE_ACHIEVEMENT_MUTATION_FIELD_NAME,
  args: ['trackId', 'urlSlug'],
  fetcher(request, ctx) {
    var _ctx$customClient;
    return ((_ctx$customClient = ctx.customClient) !== null && _ctx$customClient !== void 0 ? _ctx$customClient : chirpClient).call(References.createAchievementRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.learning.center.user.progress.rpc.AchievementChirpService#updateAchievementVisibility
 */
export const UPDATE_ACHIEVEMENT_VISIBILITY_MUTATION_FIELD_NAME = 'com_hubspot_learning_center_user_progress_rpc_AchievementChirpService_updateAchievementVisibility';
export const UPDATE_ACHIEVEMENT_VISIBILITY_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: UPDATE_ACHIEVEMENT_VISIBILITY_MUTATION_FIELD_NAME,
  args: ['achievementPublicId', 'visibilityType'],
  fetcher(request, ctx) {
    var _ctx$customClient2;
    return ((_ctx$customClient2 = ctx.customClient) !== null && _ctx$customClient2 !== void 0 ? _ctx$customClient2 : chirpClient).call(References.updateAchievementVisibilityRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.learning.center.user.progress.rpc.AchievementChirpService#getAllAchievements
 */
export const GET_ALL_ACHIEVEMENTS_QUERY_FIELD_NAME = 'com_hubspot_learning_center_user_progress_rpc_AchievementChirpService_getAllAchievements';
export const GET_ALL_ACHIEVEMENTS_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_ALL_ACHIEVEMENTS_QUERY_FIELD_NAME,
  args: [],
  fetcher(_, ctx) {
    var _ctx$customClient3;
    return ((_ctx$customClient3 = ctx.customClient) !== null && _ctx$customClient3 !== void 0 ? _ctx$customClient3 : chirpClient).call(References.getAllAchievementsRpc, {
      timeout: ctx.timeout
    });
  }
});